export interface StudentApplicationForm {
  prefix: string
  first_name: string
  last_name: string
  birth_date: string
  gender_id: string
  nationality_id: string
  email: string
  contact_number: string
  permanent_country_id: string
  permanent_city: string
  permanent_address: string
  current_country_id: string
  current_city: string
  current_address: string
  permanent_zip_code: string
  current_zip_code: string
  section_id: string
  photo: string
  program_id: string
  academic_year_id: string
  intake_id: string
  study_mode: string
  sponsor_type: string
  sponsor: string
  organization_id: string
  discount: any
  parent_fullname: string
  parent_email: string
  parent_contact_number: string
  parent_address: string
  registration_fee: string
  admission_fee: string
  study_fee: string
  currency_id: string
  email_content: string
  bank_id: string
  start_date: string
  student_type: string
  // payments
  payment_date: string
  payment_method: string
  details: string
  notes: string
  email_subject: string
  student_full_id: string
  condition: string
  condition_fr: string
  letter_date: string
  status: string
  extra: string
  extra_fr: string
  student_ids: string[]
  how_did_you_hear: string
  campus_id: string
  partner_campus: string
  installment_number: number
  installment_interval: number
}

export const initialValues: StudentApplicationForm = {
  prefix: '',
  first_name: '',
  last_name: '',
  birth_date: '',
  gender_id: '',
  nationality_id: '',
  email: '',
  contact_number: '',
  permanent_country_id: '',
  permanent_city: '',
  permanent_address: '',
  current_country_id: '',
  current_city: '',
  current_address: '',
  permanent_zip_code: '',
  current_zip_code: '',
  section_id: '',
  photo: '',
  program_id: '',
  academic_year_id: '',
  intake_id: '',
  study_mode: '',
  sponsor_type: '',
  sponsor: '',
  organization_id: '',
  discount: 0,
  parent_fullname: '',
  parent_email: '',
  parent_contact_number: '',
  parent_address: '',
  registration_fee: '0',
  admission_fee: '0',
  study_fee: '0',
  currency_id: '',
  email_content: '',
  bank_id: '',
  start_date: '',
  payment_date: '',
  payment_method: '',
  details: '',
  notes: '',
  email_subject: '',
  student_full_id: '',
  condition: '',
  condition_fr: '',
  letter_date: '',
  status: '',
  student_type: '',
  extra: '',
  extra_fr: '',
  student_ids: [],
  how_did_you_hear: '',
  campus_id: '',
  partner_campus: '',
  installment_number: 0,
  installment_interval: 0,
}

export interface StudentDocument {
  student_id: string
  title: string
  document: string
}

export const initValues: StudentDocument = {
  student_id: '',
  title: '',
  document: '',
}

export interface StudentNote {
  student_id: string
  note: string
  date: string
}

export const initVals: StudentNote = {
  student_id: '',
  note: '',
  date: '',
}

export interface EmailApplication {
  content: string
}

export const initVal: EmailApplication = {
  content: '',
}

export interface StudentCard {
  issue_date: string
  expire_date: string
}

export const intVals: StudentCard = {
  issue_date: '',
  expire_date: '',
}
